import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { ItemService } from '../services';
import { ItemEditContextModel } from '../services/item.service';

@Component({
    selector: 'digest-container',
    template: `
        <mat-toolbar color="primary">
            <app-nav></app-nav>
            <span fxFlex></span>
            <logo></logo>
            <span fxFlex></span>
            <create-topic-link></create-topic-link>
            <app-right-nav></app-right-nav>
        </mat-toolbar>
        <mat-sidenav-container fxFill>
            <router-outlet></router-outlet>
            <mat-sidenav [autoFocus]="false" mode="over" position="end" #rightSideNav (closedStart)="closingTime()">
                <item-viewer *ngIf="focusedItemContext" 
                             [itemContext]="focusedItemContext"
                             [curating]="focusedItemContext?.isCuration"
                             (close)="close()"></item-viewer>
                <div *ngIf="focusedItemEditContext">
                    <item-post [itemEditContextModel]="focusedItemEditContext"
                               (done)="close(100)"></item-post>
                </div>
            </mat-sidenav>
        </mat-sidenav-container>
    `
})
export class SearchRouteComponent implements OnInit, OnDestroy {
    @ViewChild('rightSideNav', { static: true }) rightSideNav;
    private cleanupTime = new Subject<void>();
    tenant: any;
    focusedItemContext: any;
    focusedItemEditContext: ItemEditContextModel;
    
    constructor(private route: ActivatedRoute,
        private itemService: ItemService) {}
    
    ngOnInit(): void {
        this.route.data.pipe(first()).subscribe(data => {
            this.tenant = data.tenant;
        });

        this.itemService.focusedItem.pipe(takeUntil(this.cleanupTime))
        .subscribe(item => {
            this.focusedItemContext = item;
            if (item) {
                this.rightSideNav?.open();
            } else {
                this.rightSideNav?.close();
            }
        });

        this.itemService.focusedItemEdit.pipe(takeUntil(this.cleanupTime))
        .subscribe(context => {
            this.focusedItemEditContext = context;
            if (context) {
                this.rightSideNav?.open();
            } else {
                this.rightSideNav?.close();
            }
        });
    }

    showItem(item) {
        return this.tenant && this.tenant.settings && 
        (!this.tenant.settings.clientDigestMenuOptions || this.tenant.settings.clientDigestMenuOptions.indexOf(item) !== -1);
    }

    closingTime(): void {
        this.itemService.itemClosing.next();
    }

    close(wait = 0): void {
        setTimeout(() => this.rightSideNav.close(), wait);
    }

    ngOnDestroy(): void {
        this.cleanupTime.next();
        this.cleanupTime.complete();
    }
}
